const TitleAccent = () => {
    return (
        <div className='w-1 h-6 rounded-sm overflow-hidden'>
            <div className='w-full h-1/2 bg-primary-light' />
            <div className='w-full h-1/2 bg-primary' />
        </div>
    );
};

export default TitleAccent;
